export function cast<T>(x: unknown): T {
  return x as T
}
